module.exports = __webpack_public_path__ + "static/inuagrates-project-c18951a5b64c1ffa5a1ba71d9964c4cf.png";